// store/useUIStore.ts
import { defineStore } from 'pinia';
import { reactive, toRefs } from 'vue';
import { UIState } from '@/rennovation/planning-view/types/state/ui-state';

export const useUIStore = defineStore('ui', () => {
	// ============================================
	// STATE
	// ============================================
	const state = reactive<UIState>({
		filters: {
			selectedGroupId: null,
			searchQuery: '',
			showInactiveUsers: true,
		},
		calendar: {
			startDate: '',
			endDate: '',
			viewMode: 'day',
		},
		selectedDate: null,
		selectedUserId: null,
		isSidebarOpen: false,
		savingIds: new Set<string>(),
		hasPendingChangesInDutyModal: false,
		tabClicked: false,
	});

	// ============================================
	// GETTERS
	// ============================================
	const isSaving = (id: string): boolean => state.savingIds.has(id);

	// ============================================
	// ACTIONS
	// ============================================

	const setHasPendingChanges = (value: boolean) => {
		state.hasPendingChangesInDutyModal = value;
	};

	return {
		...toRefs(state),
		// Getters
		isSaving,
		//Actions
		setHasPendingChanges,
	};
});
